import React from "react";

import BrandMark from "../atoms/BrandMark";
import Button from "../atoms/Button";
import Container from "../atoms/Container";
import ThemeToggle from "../molecules/ThemeToggle";

export default function SiteHeader() {
  return (
    <header className="sticky top-0 z-20 border-b border-gray-200 bg-white/80 backdrop-blur dark:border-slate-700 dark:bg-slate-900/80">
      <Container>
        <div className="flex h-16 items-center justify-between">
          <a href="/" aria-label="Digar home" className="inline-flex">
            <BrandMark />
          </a>
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <Button href="/database/index.php" variant="ghost">
              Sign in
            </Button>
            <Button href="/database/signup.php">Sign up</Button>
          </div>
        </div>
      </Container>
    </header>
  );
}
